import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import SmoothScroll from "@/components/SmoothScroll";
import Splash from "@/components/Splash";
import { IntroProvider } from "@/context/IntroContext";
import Home from "@/pages/Home";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetail from "@/pages/ProjectDetail";
import JournalPage from "@/pages/JournalPage";
import LetsBegin from "@/pages/LetsBegin";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";

function SiteLayout({ children }) {
  return (
    <IntroProvider>
      <SmoothScroll>
        <Splash />
        {children}
      </SmoothScroll>
    </IntroProvider>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-right" theme="light" />
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <Routes>
              <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
              <Route path="/projects" element={<SmoothScroll><ProjectsPage /></SmoothScroll>} />
              <Route path="/projects/:slug" element={<SmoothScroll><ProjectDetail /></SmoothScroll>} />
              <Route path="/journal" element={<SmoothScroll><JournalPage /></SmoothScroll>} />
              <Route path="/lets-begin" element={<SmoothScroll><LetsBegin /></SmoothScroll>} />
              <Route path="/admin" element={<Login />} />
              <Route path="/admin/dashboard" element={<Dashboard />} />
            </Routes>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
